export default __webpack_public_path__ + "static/media/logo.3f18e203.svg";